// extracted by mini-css-extract-plugin
export var carrierIcon = "_wf-0";
export var carrierLogo = "_wf-1";
export var detailsSection = "_wf-2";